import { ANNOUNCEMENT_MODE, ANNOUNCEMENT_ERROR } from 'containers/ClanLanding/components/AnnouncementsCard/constants'
import {
    changeMode,

    ANNOUNCEMENTS_LIST,
    ANNOUNCEMENTS_SETTINGS,
    ANNOUNCEMENTS_ERROR,
} from './index'

import {
    NOTIFICATION_MESSAGE_KEY as NOTIFICATION_TYPE,
    displayErrorNotification,
} from './notification'

const ERROR_CODE = {
    PERMISSION_REQUIRED: 3,
    MESSAGE_NOT_FOUND: 114,
    LIMIT_REACHED: 115,
    VALIDATION_ERROR: 4,
}

const ERROR_TYPE = {
    PERMISSION_REQUIRED: 'permission_required',
    MESSAGE_NOT_FOUND: 'message_not_found',
    LIMIT_REACHED: 'limit_reached',
    LENGTH_EXCEEDED: 'max_length',
    RULES_VIOLATION: 'clan_rules_violation',
    COMMON_ERROR: 'common_error',
}

const ERROR_TYPE_MAP = {
    [ERROR_CODE.PERMISSION_REQUIRED]: ERROR_TYPE.PERMISSION_REQUIRED,
    [ERROR_CODE.MESSAGE_NOT_FOUND]: ERROR_TYPE.MESSAGE_NOT_FOUND,
    [ERROR_CODE.LIMIT_REACHED]: ERROR_TYPE.LIMIT_REACHED,
    [ERROR_CODE.VALIDATION_ERROR]: [
        ERROR_TYPE.LENGTH_EXCEEDED,
        ERROR_TYPE.RULES_VIOLATION,
    ],
}

const NOTIFICATION_TYPE_MAP = {
    [ERROR_TYPE.PERMISSION_REQUIRED]: NOTIFICATION_TYPE.NO_PERMISSION,
    [ERROR_TYPE.MESSAGE_NOT_FOUND]: NOTIFICATION_TYPE.NOT_EXIST,
    [ERROR_TYPE.RULES_VIOLATION]: NOTIFICATION_TYPE.RULES_VIOLATED,
    [ERROR_TYPE.LIMIT_REACHED]: NOTIFICATION_TYPE.LIMIT_REACHED,
    [ERROR_TYPE.LENGTH_EXCEEDED]: NOTIFICATION_TYPE.LENGTH_EXCEEDED,
    [ERROR_TYPE.COMMON_ERROR]: NOTIFICATION_TYPE.COMMON_ERROR,
}

const getValidationErrors = ({ message }) => {
    const errors = Array.isArray(message) ?
        ERROR_TYPE_MAP[ERROR_CODE.VALIDATION_ERROR].filter((type) => message.includes(type)) :
        []

    return errors.length ? errors : [ERROR_TYPE.COMMON_ERROR]
}

const getErrors = ({ code, additional_data }) => {
    if (!ERROR_TYPE_MAP[code]) {
        return [ERROR_TYPE.COMMON_ERROR]
    }

    if (code === ERROR_CODE.VALIDATION_ERROR) {
        return getValidationErrors(additional_data)
    }

    return [ERROR_TYPE_MAP[code]]
}

export const handleErrors = (actionType, errorResponse, messageId = null) => {
    return (dispatch, getState) => {
        const { announcements } = getState()
        const { prevMode, list, settings } = announcements

        const errors = getErrors(errorResponse)

        errors.forEach((error) => {
            displayErrorNotification(NOTIFICATION_TYPE_MAP[error])
        })

        if (errors.includes(ERROR_TYPE.PERMISSION_REQUIRED)) {
            dispatch({
                type: ANNOUNCEMENTS_SETTINGS,
                payload: { ...settings, can_create_messages: false },
            })

            dispatch(changeMode(prevMode))
        } else if (errors.includes(ERROR_TYPE.LIMIT_REACHED)) {
            dispatch({
                type: ANNOUNCEMENTS_SETTINGS,
                payload: { ...settings, is_limit_reached: true },
            })

            dispatch(changeMode(prevMode))
        } else if (errors.includes(ERROR_TYPE.MESSAGE_NOT_FOUND)) {
            dispatch({
                type: ANNOUNCEMENTS_LIST,
                payload: list.filter((item) => item.message_id !== messageId),
            })

            dispatch(changeMode(ANNOUNCEMENT_MODE.CARD))
        }

        if (errors.includes(ERROR_TYPE.RULES_VIOLATION)) {
            dispatch({ type: ANNOUNCEMENTS_ERROR, payload: ANNOUNCEMENT_ERROR.FORBIDDEN_WORDS })
        } else {
            dispatch({ type: ANNOUNCEMENTS_ERROR, payload: actionType })
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/announcements/errors.js